
/* styles */
require("!!vue-style-loader!css-loader?minimize!../../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-367a2fe0\",\"scoped\":true,\"hasInlineConfig\":false}!postcss-loader!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./DimensionInput.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./DimensionInput.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-367a2fe0\"}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./DimensionInput.vue"),
  /* scopeId */
  "data-v-367a2fe0",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/client/components/DimensionInput.vue
// module id = 551
// module chunks = 1